(function() {
    "use strict";
    if (window.__GetCheckout)
        return;
    const CONFIG = {
        redirectPath: "/process/checkout",
        test: !1,
        testParam: "checkout_test",
        keepTestParam: !0,
        stripTestParamFromUrlOnLoad: !1,
        dynamicCheckoutSelectors: [".shopify-payment-button__button", ".product-form__submit.button"],
        customCheckoutSelectors: [".easc-checkoutBtn", ".upcart-checkout-button"],
        log: !1
    }
      , logger = {
        log: (...args) => CONFIG.log && console.log("[GetCheckout]", ...args),
        warn: (...args) => CONFIG.log && console.warn("[GetCheckout]", ...args),
        error: (...args) => CONFIG.log && console.error("[GetCheckout]", ...args)
    };
    function getCookie(name) {
        const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return match ? decodeURIComponent(match[1]) : ""
    }
    function pickUTMsFromCurrentLocation() {
        const allowed = new Set(["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "fbclid", "ttclid", "gclid"])
          , src = new URLSearchParams(window.location.search)
          , out = new URLSearchParams;
        for (const [k,v] of src.entries())
            allowed.has(k) && v && out.set(k, v);
        return out
    }
    function getTestParamValue() {
        try {
            return new URLSearchParams(window.location.search).get(CONFIG.testParam)
        } catch {
            return null
        }
    }
    function shouldActivate() {
        return CONFIG.test ? getTestParamValue() === "true" : !0
    }
    function getStoredTestFlag() {
        try {
            return localStorage.getItem(CONFIG.testParam) === "true"
        } catch {
            return !1
        }
    }
    function setStoredTestFlag(val) {
        try {
            val ? localStorage.setItem(CONFIG.testParam, "true") : localStorage.removeItem(CONFIG.testParam)
        } catch {}
    }
    function stripTestParamFromCurrentUrl() {
        try {
            const params = new URLSearchParams(window.location.search);
            if (params.has(CONFIG.testParam)) {
                params.delete(CONFIG.testParam);
                const qs = params.toString()
                  , newUrl = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
                window.history.replaceState({}, "", newUrl)
            }
        } catch {}
    }
    function addTestParamToCurrentUrl() {
        try {
            const params = new URLSearchParams(window.location.search);
            if (params.get(CONFIG.testParam) !== "true") {
                params.set(CONFIG.testParam, "true");
                const qs = params.toString()
                  , newUrl = window.location.pathname + (qs ? "?" + qs : "") + window.location.hash;
                window.history.replaceState({}, "", newUrl)
            }
        } catch {}
    }
    function reconcileTestFlag() {
        const urlVal = getTestParamValue();
        if (!CONFIG.test) {
            setStoredTestFlag(!1),
            urlVal !== null && stripTestParamFromCurrentUrl();
            return
        }
        if (urlVal === "true") {
            setStoredTestFlag(!0);
            return
        }
        if (urlVal === "false") {
            setStoredTestFlag(!1),
            stripTestParamFromCurrentUrl();
            return
        }
        getStoredTestFlag() && addTestParamToCurrentUrl()
    }
    function saveUTMs(params) {
        try {
            localStorage.setItem("get-checkout-utm", params.toString())
        } catch (e) {
            logger.warn("Unable to store UTM params", e)
        }
    }
    function loadUTMs() {
        try {
            const str = localStorage.getItem("get-checkout-utm");
            return new URLSearchParams(str || "")
        } catch (e) {
            return logger.warn("Unable to read UTM params", e),
            new URLSearchParams
        }
    }
    function ensureUTMsStored() {
        const current = pickUTMsFromCurrentLocation();
        [...current.keys()].length && saveUTMs(current)
    }
    async function getCartToken() {
        let token = getCookie("cart");
        if (token)
            return token;
        try {
            const res = await fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart.js", {
                credentials: "same-origin"
            });
            if (res.ok) {
                const data = await res.json();
                if (data && data.token)
                    return data.token
            }
        } catch (e) {
            logger.warn("Failed to fetch cart token via /cart.js", e)
        }
        return ""
    }
    function buildRedirectURL(cartToken) {
        const url = new URL(CONFIG.redirectPath,window.location.origin)
          , params = loadUTMs();
        return cartToken && params.set("cart", cartToken),
        CONFIG.test && CONFIG.keepTestParam && getTestParamValue() === "true" && params.set(CONFIG.testParam, "true"),
        url.search = params.toString(),
        url.toString()
    }
    function isCheckoutPathname(pathname) {
        return /(^|\/)checkout(\b|\/)/.test(pathname)
    }
    function isCheckoutLink(a) {
        if (!a || !a.href)
            return !1;
        const url = new URL(a.getAttribute("href"),window.location.origin);
        return url.origin !== window.location.origin ? !1 : isCheckoutPathname(url.pathname)
    }
    function isCheckoutForm(form) {
        if (!form)
            return !1;
        const action = form.getAttribute("action") || "";
        try {
            const url = new URL(action,window.location.origin);
            return isCheckoutPathname(url.pathname)
        } catch {
            return action.includes("/checkout")
        }
    }
    function isDynamicCheckoutButton(el) {
        if (!el)
            return !1;
        try {
            for (const sel of CONFIG.dynamicCheckoutSelectors)
                if (typeof sel == "string" && el.closest && el.closest(sel))
                    return !0
        } catch {}
        return !1
    }
    function isCustomCheckoutButton(el) {
        if (!el)
            return !1;
        try {
            for (const sel of CONFIG.customCheckoutSelectors)
                if (typeof sel == "string" && el.closest && el.closest(sel))
                    return !0
        } catch {}
        return !1
    }
    function findClosestProductForm(fromEl) {
        return !fromEl || !(fromEl instanceof Element) ? null : fromEl.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]')
    }
    async function addFormToCart(form) {
        if (!form)
            return !1;
        try {
            const fd = new FormData(form)
              , endpoint = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/") + "cart/add.js"
              , res = await fetch(endpoint, {
                method: "POST",
                body: fd,
                credentials: "same-origin"
            });
            return res.ok ? (await res.json().catch( () => ({})),
            !0) : (logger.warn("cart/add failed with status", res.status),
            !1)
        } catch (e) {
            return logger.warn("cart/add error", e),
            !1
        }
    }
    class GetCheckout {
        constructor() {
            if (this.redirectLoading = !1,
            this.onClickCapture = this.onClickCapture.bind(this),
            this.onAuxClickCapture = this.onAuxClickCapture.bind(this),
            this.onSubmitCapture = this.onSubmitCapture.bind(this),
            this.onKeydownCapture = this.onKeydownCapture.bind(this),
            ensureUTMsStored(),
            reconcileTestFlag(),
            this.active = shouldActivate(),
            !this.active) {
                logger.log("inactive (test mode enabled but no test flag present)");
                return
            }
            
            const isUkraine = getCookie('localization') === 'UA';

            if(!isUkraine) {
                return;
            }
            
            this.guardDirectCheckoutLoad(),
            document.addEventListener("click", this.onClickCapture, !0),
            document.addEventListener("auxclick", this.onAuxClickCapture, !0),
            document.addEventListener("submit", this.onSubmitCapture, !0),
            document.addEventListener("keydown", this.onKeydownCapture, !0),
            logger.log("initialized")
        }
        async toCheckout(afterAdd=!1) {
            if (!this.redirectLoading) {
                this.redirectLoading = !0;
                try {
                    const token = await getCartToken()
                      , target = buildRedirectURL(token);
                    logger.log("redirecting to", target, afterAdd ? "(after add)" : ""),
                    window.location.href = target
                } finally {
                    setTimeout( () => {
                        this.redirectLoading = !1
                    }
                    , 1e3)
                }
            }
        }
        guardDirectCheckoutLoad() {
            try {
                isCheckoutPathname(window.location.pathname) && getCartToken().then(token => {
                    const target = buildRedirectURL(token);
                    logger.log("guard redirect from /checkout to", target),
                    window.location.replace(target)
                }
                )
            } catch (e) {
                logger.warn("guardDirectCheckoutLoad error", e)
            }
        }
        async onClickCapture(e) {
            const target = e.target instanceof Element ? e.target : null;
            if (!target)
                return;
            const anchor = target.closest("a");
            if (anchor && isCheckoutLink(anchor))
                return e.preventDefault(),
                e.stopPropagation(),
                this.toCheckout();
            const btnOrInput = target.closest("button, input, a");
            if (target.shadowRoot) {
                const btnOrInput2 = target.shadowRoot.querySelector('a[href*="/checkout"]') || target.shadowRoot.querySelector('a[href*="/cart"]');
                btnOrInput2.removeEventListener("click", this.onClickCapture, !0),
                btnOrInput2.addEventListener("click", this.onClickCapture, !0);
                return
            }
            if (btnOrInput) {
                if (btnOrInput.getAttribute("name") === "checkout")
                    return e.preventDefault(),
                    e.stopPropagation(),
                    this.toCheckout();
                if (isCustomCheckoutButton(btnOrInput))
                    return e.preventDefault(),
                    e.stopPropagation(),
                    this.toCheckout();
                if (isDynamicCheckoutButton(btnOrInput)) {
                    e.preventDefault(),
                    e.stopPropagation();
                    const form2 = findClosestProductForm(btnOrInput);
                    return await addFormToCart(form2),
                    this.toCheckout(!0)
                }
            }
            const form = target.closest("form");
            if (form && isCheckoutForm(form))
                return e.preventDefault(),
                e.stopPropagation(),
                this.toCheckout()
        }
        onAuxClickCapture(e) {
            if (e.button !== 1)
                return;
            const target = e.target instanceof Element ? e.target : null;
            if (!target)
                return;
            const anchor = target.closest("a");
            anchor && isCheckoutLink(anchor) && (e.preventDefault(),
            e.stopPropagation(),
            this.toCheckout())
        }
        onSubmitCapture(e) {
            const form = e.target instanceof HTMLFormElement ? e.target : null;
            form && isCheckoutForm(form) && (e.preventDefault(),
            e.stopPropagation(),
            this.toCheckout())
        }
        onKeydownCapture(e) {
            if (e.key !== "Enter")
                return;
            const target = e.target instanceof Element ? e.target : null;
            if (!target)
                return;
            const form = target.closest("form");
            form && isCheckoutForm(form) && (e.preventDefault(),
            e.stopPropagation(),
            this.toCheckout())
        }
    }
    window.__GetCheckout = new GetCheckout
}
)();
//# sourceMappingURL=/cdn/shop/t/21/assets/get-checkout.js.map?v=25355932907844537631774012658
